import { Box, Hidden, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SidebarLinks } from "../../config/SidebarLinks";
import { AuthRepository } from "../repositories/AuthRepository";
import { useDispatch, useSelector } from "react-redux";
import { setMenuOpen } from "../../store/MenuSlice";
import { IoMdClose } from "react-icons/io";
import { AiOutlineHome } from "react-icons/ai";

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const taskCounts = useSelector((state) => state.taskCount);

  const drawerWidth = 100;
  const menu = useSelector((state) => state.menu);
  const dispatch = useDispatch();
  const menuItems = SidebarLinks.filter((item) =>
    AuthRepository.hasAnyRole(item.roles),
  );
  const [selectedItem, setSelectedItem] = useState({
    title: "Почетна",
    icon: <AiOutlineHome />,
  });

  return (
    <Box
      sx={{
        width: `${drawerWidth}px`,
        height: "100vh",
        background:
          "linear-gradient(135deg, rgb(4, 85, 152), rgb(0, 112, 204))",
        display: {
          xs: menu?.open ? "flex" : "none", // hidden on phones
          sm: "flex", // hidden on tablets
          md: "flex", // visible on desktop and up
        },
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        zIndex: 9999,
      }}
    >
      <Hidden mdUp>
        <IconButton
          onClick={() => dispatch(setMenuOpen(false))}
          sx={{ color: "white", alignSelf: "center", margin: 1 }}
        >
          <IoMdClose fontSize={32} />
        </IconButton>
      </Hidden>

      {menuItems.map((item, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            marginTop: index === 0 ? "100px" : 0,
            cursor: "pointer",
            userSelect: "none",
            padding: "4px",
            width: 85,
            height: 75,
            boxSizing: "border-box",
            backgroundColor:
              (item.path == "/" && location?.pathname == "/") ||
              (location.pathname?.includes(item.path) && item.path !== "/")
                ? "rgba(231, 231, 231, 0.2)"
                : "",
            borderRadius:
              (item.path == "/" && location?.pathname == "/") ||
              (location.pathname?.includes(item.path) && item.path !== "/")
                ? "3px"
                : "",
            "&:hover": {
              borderRadius: "3px",
              backgroundColor: "rgba(231, 231, 231, 0.2)",
            },
          }}
          onClick={() => {
            setSelectedItem(item);
            dispatch(setMenuOpen(false));
            navigate(item.path || "/");
          }}
        >
          {React.cloneElement(
            (item.path == "/" && location?.pathname == "/") ||
              (location.pathname?.includes(item.path) && item.path !== "/")
              ? item.selectedIcon
              : item.icon,
            {
              size: 23,
              color:
                (item.path == "/" && location?.pathname == "/") ||
                (location.pathname?.includes(item.path) && item.path !== "/")
                  ? "#e59900"
                  : "white",
            },
          )}

          <Typography
            variant="body2"
            align="center"
            sx={{
              whiteSpace: "pre-line",
              marginTop: 1,
              fontSize: "14px",
              fontFamily: "Inter-Regular",
              letterSpacing: "0.2px",
              lineHeight: "1.2",
            }}
          >
            {(() => {
              const words = item.title.split(" ");
              const mid = Math.ceil(words.length / 2);
              const firstLine = words.slice(0, mid).join(" ");
              const secondLine = words.slice(mid).join(" ");
              return `${firstLine}\n${secondLine}`;
            })()}
          </Typography>

          {item?.taskCountProperty &&
          taskCounts &&
          taskCounts[item.taskCountProperty] &&
          taskCounts[item.taskCountProperty] > 0 ? (
            <Box
              sx={{
                position: "absolute",
                marginBottom: "40px",
                marginLeft: "60px",
                background: "rgb(228, 53, 33)",
                color: "white",
                borderRadius: "50%",
                width: "20px",
                height: "20px",
                fontSize: "13px",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {taskCounts[item.taskCountProperty]}
            </Box>
          ) : null}
        </Box>
      ))}
    </Box>
  );
}
